export default '/build/6b78048e.svg'